import { render, staticRenderFns } from "./UsersShareViewsBrowse.vue?vue&type=template&id=4b0b394e&scoped=true"
import script from "./UsersShareViewsBrowse.vue?vue&type=script&lang=ts"
export * from "./UsersShareViewsBrowse.vue?vue&type=script&lang=ts"
import style0 from "./UsersShareViewsBrowse.vue?vue&type=style&index=0&id=4b0b394e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0b394e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b0b394e')) {
      api.createRecord('4b0b394e', component.options)
    } else {
      api.reload('4b0b394e', component.options)
    }
    module.hot.accept("./UsersShareViewsBrowse.vue?vue&type=template&id=4b0b394e&scoped=true", function () {
      api.rerender('4b0b394e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/UsersShareViewsBrowse.vue"
export default component.exports